import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberVerticalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronGrabberVerticalToward"><Path d="M8 5.25L12 9.25L16 5.25" stroke="currentColor" strokeLinecap="square"/><Path d="M8 18.75L12 14.75L16 18.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronGrabberVerticalToward;
